import React, { useEffect, useRef } from 'react';
import { default_design } from '../../static/default_design';
import { drawType } from '../utilsDesign';
import { Bodygraph } from './Bodygraph';



export const Preview = React.memo(({
  default_colors = 'base',
  markers,
  penta,
  composite,
  hints,
  hoverable,
  interactive,
  children,
  body = true,
  simplified,
  activePage,
  design = default_design,
  lines = true,
  openTransparent,
  omitGates,
  omitCenters,
  questionPlanets,
  blur,
  numbers,
  width,
  height,
  aura = true,
  bg = false,
  planets,
  planetsDes,
  planetsPrs,
  authority,
  arrowsB,
  arrowsP,
  opacity = 1,
  bodyAdd,
  style,
  className,
  preloader,
  advanced,
  setloadingBody = () => void (0),
  parentContainer,
  colorTheme = {},
  focusedCenter,
  highlighted,
  highlightedGate = [],
  addClassName = '',
  png = false,
  avatarToken,
  avatarUpdated,
  '3d': threeD,
  mode3d,
  orbit3d,
  autoRotate3d,
  appear3d,
}) => {


  useEffect(() => {
    setloadingBody(false)
  })

  const withoutHighlighted = (center) => {
    let centers = ['HD', 'AA', 'TT', 'HT', 'GC', 'SN', 'SL', 'SP', 'RT'];

    if (center) {
      let indToDelete = centers.findIndex((one) => one === center);
      centers.splice(indToDelete, 1)
    }
    return centers;
  }

  const bodyContainer = useRef(null);

  parentContainer = parentContainer || bodyContainer;

  // useEffect(() => {
  //   console.log('design = ', design);
  // }, [design])


  return (
    <>

        {children}





      {!simplified
        && <div
          className={`x_bodygraph0`}
          // style={{ position: 'absolute' }}
        >

          <Bodygraph
            default_colors={default_colors}
            markers={markers}
            penta={penta}
            composite={composite}
            hints={hints}
            hoverable={hoverable}
            interactive={interactive}
            width={width}
            height={height}
            numbers={numbers}
            lines={lines}
            openTransparent={openTransparent}
            omitGates={omitGates}
            omitCenters={omitCenters}
            questionPlanets={questionPlanets}
            arrowsB={arrowsB}
            arrowsP={arrowsP}
            planets={planets}
            planetsPrs={planetsPrs}
            planetsDes={planetsDes}
            aura={false}
            advanced={advanced}
            activePage={activePage}
            design={design}
            {...bodyAdd}
            preloader={preloader}
            parentContainer={parentContainer}
            colorTheme={colorTheme}
            focusedCenter={focusedCenter}
            highlighted={highlighted}
            highlightedGate={highlightedGate}
            addClassName={addClassName}
            png={png}
            avatarToken={avatarToken}
            avatarUpdated={avatarUpdated}
            mode3d={mode3d || threeD}
            orbit3d={orbit3d}
            autoRotate3d={autoRotate3d}
            appear3d={appear3d}
          />

        </div>}


      {bg
        && <div className={`x_edu_bg ${design && drawType(design['type'], 'class')}`}
          style={{ width: '100%' }}
        >
      {aura
        && <div className={`x_edu_aurabg ${aura ? 'active' : ''} ${design && drawType(design['type'], 'class')} page--${activePage}`}></div>}
        </div>}
    </>

  )
})





